export default "__VITE_ASSET__BxV5$1Tl__"